import { FC, useState } from 'react';

import { Form, Select } from 'antd';
import { Input, Label } from 'ui';
import { formRules } from 'utils/formRules';

import { EventTicketType } from 'types/events/eventTypes';
import { OfferType } from 'types/promoters/promoterTypes';

import EventOfferSetTicketType from '../event-offer-set-ticket-type';
import s from './EventOfferGreaterNumberTickets.module.scss';

interface EventOfferGreaterNumberTicketsProps {
  tickets?: EventTicketType[];
  ticketTypes?: {
    ticketType?: EventTicketType;
    ticketTypeId?: string;
    id?: string;
    priceToBeSold?: number;
    minimumNumberOfTicketsToBeBought?: number;
  }[];
  setTicketTypes: (
    ticketTypes: {
      id: string;
      ticketType: EventTicketType;
      priceToBeSold?: number;
      minimumNumberOfTicketsToBeBought?: number;
    }[],
  ) => void;
}

const EventOfferGreaterNumberTickets: FC<EventOfferGreaterNumberTicketsProps> = ({
  tickets,
  ticketTypes,
  setTicketTypes,
}) => {
  const [discountType, setDiscountType] = useState<string>('%');
  return (
    <div className={s.wrapper}>
      <EventOfferSetTicketType
        offerType={OfferType.greaterOrEqualToNumberOfTickets}
        ticketTypes={ticketTypes}
        tickets={tickets}
        setTicketTypes={setTicketTypes}
      />
      <div className={s.row}>
        <div className={s.item}>
          <Label required>Number of tickets to purchase</Label>
          <Form.Item rules={[formRules.required]} name="numberOfTicketsToGetDiscount" label="">
            <Input.Number
              style={{ width: '100%' }}
              name="numberOfTicketsToGetDiscount"
              size="middle"></Input.Number>
          </Form.Item>
        </div>
      </div>
      <div className={s.row}>
        <div className={s.item}>
          <Label required>Discount</Label>
          <Form.Item rules={[formRules.required]} name="fixedDiscount" label="">
            <Input.Number
              style={{ width: '100%' }}
              name="fixedDiscount"
              size="middle"></Input.Number>
          </Form.Item>
        </div>
        <div className={s.item}>
          <Label>Type</Label>
          <Form.Item name="fixedDiscountValueType" label="">
            <Select
              style={{ width: '100%', height: 40 }}
              onChange={(value) => setDiscountType(value)}
              options={[
                { value: 'percentage', label: '%' },
                { value: 'fixedValue', label: '€' },
              ]}
              value={discountType}
              defaultValue="percentage"
            />
          </Form.Item>
        </div>
      </div>
    </div>
  );
};

export default EventOfferGreaterNumberTickets;
